<template>
  <div
    class="m-banner-wrap"
  >
    <Swiper
      v-if="bannerList.length > 1"
      ref="bannerSwiper"
      :options="swiperOption"
    >
      <template v-for="(item, index) in bannerList">
        <SwiperSlide :key="index">
          <BannerItem
            :banner="item"
            :source="source"
            :order="index"
          />
        </SwiperSlide>
      </template>

      <div
        v-if="bannerList.length > 1"
        slot="pagination"
        class="swiper-pagination"
      />
    </Swiper>

    <div
      v-else
      class="swiper"
    >
      <BannerItem
        :banner="bannerList[0]"
        :source="source"
        :order="0"
      />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-slim-swiper'
import BannerItem from './BannerItem.vue'

export default {
  name: 'BannerList',
  components: {
    Swiper,
    SwiperSlide,
    BannerItem
  },
  props: {
    bannerList: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      swiperOption: {
        // 区分登录态显示不同 banner，所以需要在登录状态变化后更新 swiper
        observer: true,
        speed: 800,
        loop: true,
        // loopAdditionalSlides: 0,
        pagination: {
          el: '.swiper-pagination'
        },
        // 避免无间隔时图片错位叠加
        spaceBetween: 0.5,
        observeParents: true,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        // lazy: true
        // lazy: {
        //   loadPrevNext: true
        // },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      }
    }
  },
  // mounted () {
  // if (this.bannerList.length > 1) {
  //   this.startAutoplay()
  // }
  // },
  activated() {
    const { bannerSwiper } = this.$refs
    if (this.bannerList.length > 1 && bannerSwiper) {
      const { swiper } = bannerSwiper
      swiper && swiper.autoplay.start()
    }
  },
  deactivated() {
    const { bannerSwiper } = this.$refs
    if (this.bannerList.length > 1 && bannerSwiper) {
      const { swiper } = bannerSwiper
      swiper && swiper.autoplay.stop()
    }
  },
  updated() {
    const { bannerSwiper } = this.$refs
    if (bannerSwiper) {
      const { swiper } = bannerSwiper
      if (swiper) {
        this.$nextTick(() => {
          swiper.loopDestroy()
          swiper.loopCreate()
        })
      }
    }
  },
  methods: {
    // 等第一张图加载完成在开始 autoplay
    startAutoplay() {
      const autoplay = () => {
        const { bannerSwiper } = this.$refs
        if (!bannerSwiper) return
        const { swiper } = bannerSwiper
        this.swiper = swiper
        if (!this.swiperOption.autoplay) {
          swiper.params.autoplay = {
            delay: 3000,
            disableOnInteraction: false
          }
          swiper.autoplay.start()
        }
      }

      const firstImg = this.$el.querySelector('.m-banner-item img')
      if (firstImg) {
        if (firstImg.complete) {
          autoplay()
        }
        firstImg.onload = () => autoplay()
        firstImg.onerror = () => autoplay()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.m-banner-wrap {
  box-sizing: border-box;
  padding: 0 10px;

  ::v-deep {
    .swiper {
      overflow: hidden;
      width: 100%;
      border-radius: 8px;
      margin: 0 auto;
      // fix safari border-radius + oveflow 不生效的问题
      mask-image: radial-gradient(white, black);
    }

    .swiper-pagination {
      position: absolute;
      bottom: 9px;
      left: 50%;
      display: flex;
      justify-content: center;
      transform: translate3d(-50%, 0, 0);

      .swiper-pagination-bullet {
        display: inline-block;
        width: 4px;
        height: 4px;
        border: 0;
        margin: 0 2px;
        background: #fff;
        opacity: 0.8;

        &.swiper-pagination-bullet-active {
          opacity: 1;
        }
      }
    }
  }
}
</style>
